import axios from 'axios';
// import store from '../store';
// import { Toast } from 'mint-ui';
// import 'mint-ui/lib/style.css';
import { Message } from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
axios.defaults.baseURL = 'https://api.id-photo-verify.com/api/V2/'

axios.interceptors.request.use(
    config => {

        config.headers = {
            'App-Key':'ZUIMEI_ID_PHOTO_WEB',
            'Content-Type':'application/json',
            'Software-Version':'1.0.0',
            'Client-Type':'WEB',
        }
        if (localStorage.getItem('user_key')){
            config.headers['User-key'] = localStorage.getItem('user_key')
        }

        return config
    },
    error => Promise.reject(error)
)
axios.interceptors.response.use(
    res => {
        if (res.data&&res.data.code !== 200) {
            if (res.data&&res.data.code !==482){
                // 轮询接口未完成时 不用提示错误信息
                Message.error({
                    showClose: true,
                    message:res.data.error
                });
            }
            return Promise.reject(res.data);
        }else {
            return res
        }

    },
    err => {
        console.log('error response: \n', err.response)

        if (err.response && err.response.data && err.response.data.message) {
            Message.error({
                showClose: true,
                message:err.response.data.message
            });
        } else {
            Message.error({
                showClose: true,
                // type: 'error',
                message:'请求异常，请稍后再试！'
            });

        }

        return Promise.reject(err);
    },
);



// 获取user_key
const getUserKey = () => axios.get('user_key');

// 获取app信息
const getAppInfo = () => axios.get('app_switch');

// 获得上传的地址
const getUploadAddress = () => axios.get('original_oss_url?sign_headers={"Content-Type":"application/octet-stream"}')

// 制作图片返回taskId
const getCertificatePhotoTaskId = (submitData) => axios.post('cutout_beauty_cut/async', submitData);

// 通过taskId获得证件照图片
const getPhotoByTaskId = taskId => axios.get(`cutout_beauty_cut/async/${taskId}`);

// 获取热门搜索数据
const getHostList = () => axios.get('specs/hot/detail/group_url');

// 获取规格总数据
const getSizeGroup = () => axios.get('specs_group');

// 通过spec_id查询规格
const getSizeInfo = (spec_id) => axios.get(`specs_by_id/${spec_id}`);

// 规格查询
const searchSize = (keywords) => axios.get(`search_specs_group/${keywords}`);

// 获取自定义背景颜色
const getCustomBgColor = () => axios.get('background_color');

// 获取自定义规格附加规格
const getCustomExtraSpec = () => axios.get('link_resources/custom_spec_extra_spec');

// 获取换装衣服的list
const getClothesList = () => axios.get('clothes');

// 获取订单list
const getOrderList = () => axios.get(`multi_back_ele_order?order_state=all`)

// 获取常见问题
const getCommonProblem = () =>axios.get('problem/common_problem_v2')

// 生成订单流水号
const getSerialNumber = (submitData) => axios.post('cutout_beauty_cut/serial_number', submitData);

// 生成订单号
const getOrderId = (submitData) => axios.post('ele_order', submitData);

// 获取微信支付二维码
const getWxPayQrCode = (orderId) => axios.get(`wechat_pay/qrcode/${orderId}`)

// 获取支付宝支付二维码
const getZfbPayQrCode = (orderId) => axios.get(`alipay/qrcode/${orderId}`)

// 根据订单号获取订单状态
const getOrderState = (orderId) => axios.get(`order_state/${orderId}`)

// 根据订单号删除订单
const deleteOrder = (orderId) => axios.get(`delete_ele_order/${orderId}`)

// 发送邮件
const sendEmail = (orderId,submitData) => axios.post(`email/${orderId}`,submitData)








export default {
    getUserKey,
    getAppInfo,
    getUploadAddress,
    getCertificatePhotoTaskId,
    getPhotoByTaskId,
    getHostList,
    getSizeGroup,
    getSizeInfo,
    searchSize,
    getCustomBgColor,
    getCustomExtraSpec,
    getClothesList,
    getOrderList,
    getCommonProblem,
    getSerialNumber,
    getOrderId,
    getWxPayQrCode,
    getZfbPayQrCode,
    getOrderState,
    deleteOrder,
    sendEmail,
};
